/* ============
 * Report an error caught in a promise chain
 * ============
 *
 * Sentry's global handlers only see uncaught errors and unhandled rejections: an
 * exception swallowed by a `.catch()` that just logs to the console never reaches Sentry
 * (a TypeError in the order cart transformer blocked orders unnoticed, 08/10/2026). Axios errors (HTTP
 * status, network failure, cancellation) are skipped: they are not front bugs and the
 * back reports its own.
 */
import axios from 'axios';
import * as Sentry from '@sentry/vue';

export default function reportError(error, context) {
  if (context) {
    window.console.error(context, error);
  } else {
    window.console.error(error);
  }

  if (axios.isCancel(error) || (error && error.config)) {
    return;
  }

  Sentry.captureException(error, context ? { extra: { context } } : undefined);
}
